






















































































































































































































































































































































// @ts-ignore
import { getInstance } from "@/auth/auth0";
import useTour from "@/composables/useTour";
import useUsers from "@/views/modules/settings/users/useUsers";
import { defineComponent, onMounted } from "@vue/composition-api";
import {
    BAvatar,
    BButton,
    BCard,
    BCardFooter,
    BCardGroup,
    BCardText,
    BCardTitle,
    BCol,
    BContainer,
    BRow,
} from "bootstrap-vue";
import ExtraUsersRequestModal from "./users/extraUserRequestModal.vue";
import UserLimits from "./users/userLimits.vue";

export default defineComponent({
    components: {
        BContainer,
        BRow,
        BCol,
        BCard,
        BCardText,
        BCardTitle,
        BCardGroup,
        BButton,
        BCardFooter,
        BAvatar,
        UserLimits,
        ExtraUsersRequestModal,
    },
    setup() {
        const { addUserOrOpenRequestModal } = useUsers();

        onMounted(() => {
            const { shouldShow, hasSteps, startTour } = useTour("settings");
            if (shouldShow() && hasSteps.value) {
                startTour();
            }
        });

        const hasAbilityToUpdateAnyUsers = Boolean(
            getInstance().$ability.j?.find(
                (ability: { subject: string; possession: string[] }) =>
                    ability.subject === "users" && ability.possession.some((possession) => possession === "update:any")
            )
        );

        return {
            hasAbilityToUpdateAnyUsers,
            addUserOrOpenRequestModal,
        };
    },
});
